const LevelPopupType = {
    NONE: 0,
    START: 1,
    ALMOST: 2,
    NEXT: 3,
    FINISH: 4,
    GAMEOVER: 5
};

export default LevelPopupType;